import {Component, OnInit, TemplateRef} from '@angular/core';
import {CommonComponent} from '../../shared/common/common.component';
import {Router} from '@angular/router';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {NotificationsService} from '../../../services/notifications.service';
import {ToastaService} from 'ngx-toasta';
import {LangChangeEvent, TranslateService} from '@ngx-translate/core';
import {Application} from '../../../domain/onBoarding/application';
import {ApplicationService} from '../../../services/application.service';
import {DialogService} from 'primeng/dynamicdialog';
import {ConfigurationService} from '../../../services/configuration.service';

@Component({
  selector: 'app-usa-ids-screen',
  templateUrl: './usa-ids-screen.component.html',
  styleUrls: ['./usa-ids-screen.component.scss']
})
export class UsaIdsScreenComponent extends CommonComponent implements OnInit {

  application: Application;
  requiredDriversLicense: boolean;
  requiredSocialSecurityNumber: boolean;
  displayConfirm =  false;


  constructor(
    protected router: Router,
    private applicationService: ApplicationService,
    protected modalService: NgbModal,
    protected notificationsService: NotificationsService,
    protected toastService: ToastaService,
    public translate: TranslateService,
    protected dialogService: DialogService,
    public configurationService: ConfigurationService
  ) {
    super(modalService, notificationsService, toastService, router, translate, dialogService);
    this.application = applicationService.application;

    translate.onLangChange.subscribe(
      (event: LangChangeEvent) => {
      });
  }

  ngOnInit(): void {
    scroll(0, 0);
    if (!this.application || !this.application.editing) {
      this.router.navigate(['/onboarding/']);
      return;
    }
    if (this.application.body.hasSocialSecurityNumber == null) {
      this.application.body.hasSocialSecurityNumber = true;
    }
    if (this.application.ssnOrDL || this.application.body.applicationRejected) {
      this.application.body.hasSocialSecurityNumber = !!this.application.body.socialSecurityNumber;

    }
  }

  onSubmit() {
    if (!this.application.body.socialSecurityNumber ||
      (this.application.body.applicationRejected && !this.isAmericanCitizen(this.application))) {
      this.router.navigate(['onboarding/photos']);
    } else {
      this.router.navigate(['onboarding/personalData']);
    }
  }

  resetNSS() {
    if (this.application.body.socialSecurityNumber === '') {
      this.application.body.socialSecurityNumber = null;
    }
    this.application.body.identificationType = null;
    this.application.body.identification2Type = null;
    this.application.body.identificationCountry = null;
    this.application.body.identification2Country = null;
  }

  validateNss() {
    if (!this.application.body.socialSecurityNumber && !this.application.body.driverLicenseNumber) {
      this.requiredSocialSecurityNumber = true;
    }
  }


  onBack() {
    this.router.navigate(['/onboarding/contactData']);
  }

  openModal(content: TemplateRef<any>): void {
    this.modalService.open(content, {
      size: 'md',
      centered: true,
      backdrop: 'static',
      keyboard: false
    });
  }
}
